export let ExperimentIdentifier;
(function (ExperimentIdentifier) {
  ExperimentIdentifier["Uuid"] = "UUID";
  ExperimentIdentifier["Utk"] = "UTK";
  ExperimentIdentifier["PortalId"] = "PORTAL_ID";
})(ExperimentIdentifier || (ExperimentIdentifier = {}));